import React from 'react';
import { Card, Select, Space, Tabs } from 'antd';
import DeviceConnectChart from '@layouts/dashboard/DeviceConnectChart';
import { selectSearchFilter } from '@services/utils';
import { DeviceTotal, DeviceTotalChart, StbChart, StbTotal, StbTotalChart } from '@services/types';
import api from '@services/api';
import DeviceNumberChart from '@layouts/dashboard/DeviceNumberChart';
import StbDeployChart from '@layouts/dashboard/StbDeployChart';
import IncorrectReq from '@layouts/dashboard/IncorrectReq';
import ActiveDevices from '@layouts/dashboard/ActiveDevices';
import RegisteredDevices from '@layouts/dashboard/RegisteredDevices';
import { StbGroupNameResponse, StbGroupResponse } from '@openapi';
import DevicesCounterChart from '@layouts/dashboard/DevicesCounterChart';

const { Option } = Select;
const { TabPane } = Tabs;

const Dashboard = () => {
  const [devices, setDevices] = React.useState<DeviceTotal['elements']>([]);
  const [stbChart, setStbChart] = React.useState<StbGroupNameResponse[]>([]);
  const [selectDevice, setSelectDevice] = React.useState<DeviceTotalChart>();
  const [selectDeviceStb, setSelectDeviceStb] = React.useState<DeviceTotalChart>();
  const [selectStb, setSelectStb] = React.useState<any>();

  React.useEffect(() => {
    Promise.all([
      api.reports.getDeviceTotal(),
      api.reports.getStbReportNoEmpty({ filterDeviceTypeId: selectDeviceStb?.deviceTypeId }),
    ]).then(([data, stbChart]) => {
      if (data) {
        setDevices(data);
        setStbChart(stbChart);
      }
    });
  }, [selectDeviceStb]);

  const handleValueDevice = (e: string) => {
    setSelectDevice(devices?.find(({ deviceTypeId }) => deviceTypeId === e));
  };
  const handleValueDeviceStb = (e: string) => {
    setSelectDeviceStb(devices?.find(({ deviceTypeId }) => deviceTypeId === e));
  };

  const handleValueStb = (e: string) => {
    setSelectStb(stbChart?.find(({ id }) => id === e));
  };

  return (
    <>
      <div style={{ display: 'grid', gridGap: '20px' }}>
        <Card title="Total number of devices registered per day since the beginning">
          <DevicesCounterChart />
        </Card>
        <Card title="Total number of device connections per hour">
          <DeviceConnectChart />
        </Card>
        <Card title="Total number of active (distinct) device connections per day">
          <ActiveDevices />
        </Card>
        <Card title="Total number of devices registered per day">
          <RegisteredDevices />
        </Card>
      </div>
      <Card>
        <Tabs centered={true} defaultActiveKey="1" type="card" size="large">
          <TabPane tab="Device Number" key="1">
            <div style={{ display: 'grid', justifyContent: 'flex-end', padding: '15px' }}>
              <Select
                onChange={(e: string) => {
                  handleValueDevice(e);
                }}
                style={{ width: '300px' }}
                placeholder="Select a Device Type"
                allowClear
                showSearch
                defaultActiveFirstOption
                defaultOpen
                filterOption={selectSearchFilter}
              >
                {devices?.map((item) => (
                  <Option value={item.deviceTypeId} key={item.deviceTypeId}>
                    {item.deviceTypeName}
                  </Option>
                ))}
              </Select>
            </div>
            {selectDevice?.deviceTypeId && <DeviceNumberChart selectDevice={selectDevice} />}
          </TabPane>
          <TabPane tab="Deployment progress" key="2">
            <div style={{ display: 'grid', justifyContent: 'flex-end', padding: '15px' }}>
              <Space>
                <Select
                  onChange={(e: string) => {
                    handleValueDeviceStb(e);
                  }}
                  style={{ width: '300px' }}
                  placeholder="Select a Device Type"
                  allowClear
                  showSearch
                  defaultActiveFirstOption
                  defaultOpen
                  filterOption={selectSearchFilter}
                >
                  {devices?.map((item) => (
                    <Option value={item.deviceTypeId} key={item.deviceTypeId}>
                      {item.deviceTypeName}
                    </Option>
                  ))}
                </Select>
                <Select
                  onChange={(e) => handleValueStb(e)}
                  defaultActiveFirstOption
                  defaultOpen
                  style={{ width: '300px' }}
                  placeholder="Select a STB Group"
                  allowClear
                  showSearch
                  filterOption={selectSearchFilter}
                >
                  {stbChart?.map((item: any) => (
                    <Option value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Space>
            </div>
            {selectStb?.id && <StbDeployChart selectStb={selectStb} />}
          </TabPane>
          <TabPane tab="Incorrect requests" key="3">
            <IncorrectReq />
          </TabPane>
        </Tabs>
      </Card>
    </>
  );
};
export default React.memo(Dashboard);
